import './App.css';
import { RouterProvider } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { CartProvider, AuthProvider, UserProvider, PaymentProvider, WishlistProvider } from './context';
import { router } from './routes';
import ErrorBoundary from './components/common/ErrorBoundary';

function App() {
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <AuthProvider>
          <UserProvider>
            <WishlistProvider>
              <CartProvider>
                <PaymentProvider>
                  <RouterProvider router={router} />
                </PaymentProvider>
              </CartProvider>
            </WishlistProvider>
          </UserProvider>
        </AuthProvider>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
